

export const performAsyncFunction = (f: () => Promise<void | never>, onError: (err: Error) => void, ac?:AbortController|undefined) => {
	if (!ac)
	ac = new AbortController();
	
	if (ac.signal.aborted) {
		console.log("signal.aborted", ac.signal.aborted);
		return Promise.reject(new DOMException("Aborted", "AbortError"));
	} else {
		Promise.resolve(f()).catch((e: Error) => {
			onError(e);
		});
	}
};
